import { ButtonProps } from '../../atoms/Button';
import { CheckboxProps } from '../../atoms/Checkbox';
import { ChipProps } from '../../atoms/Chip';
import { IconProps } from '../../atoms/Icon';
import { TextProps } from '../../atoms/Text';
import { IconDropDownProps } from '../IconDropDown';

type TableCellInternalProps = {
  button?: ButtonProps;
  checkbox?: CheckboxProps;
  chip?: ChipProps;
  text?: TextProps;
  iconDropDown?: IconDropDownProps;
  icon?: IconProps;
};

type TableCellPropsValues = {
  'ButtonDefaultFullWidth': TableCellInternalProps;
  'CheckboxDefaultXS': TableCellInternalProps;
  'ChipDefaultS': TableCellInternalProps;
  'IconDropDownDefaultFullWidth': TableCellInternalProps;
  'IconTextActivatedM': TableCellInternalProps;
  'IconTextDestructiveM': TableCellInternalProps;
  'IconTextPendingM': TableCellInternalProps;
  'TextPaddedDefaultL': TableCellInternalProps;
  'TextPaddedDefaultM': TableCellInternalProps;
  'TextDefaultL': TableCellInternalProps;
  'TextDefaultM': TableCellInternalProps;
  'HeadingDefaultFullWidth': TableCellInternalProps;
  'TextDefaultFullWidth': TableCellInternalProps;
};

const propValues: TableCellPropsValues = {
  'ButtonDefaultFullWidth': {
    button: {
      type: 'Icon',
      size: 'S',
      styleType: 'PrimarySubdued',
      state: 'Default',
    },
  },
  'CheckboxDefaultXS': {
    checkbox: {
      state: 'Unchecked',
    },
  },
  'ChipDefaultS': {
    chip: {
      styleType: 'Default',
      size: 'M',
      type: 'Text',
      error: 'None',
      state: 'Default',
    },
  },
  'IconDropDownDefaultFullWidth': {
    iconDropDown: {
      type: 'PillButton',
    },
  },
  'IconTextActivatedM': {
    icon: {
      asset: 'SelectedFilled',
      colour: 'IconPositiveHover',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body4',
    },
  },
  'IconTextDestructiveM': {
    icon: {
      asset: 'NegativeFilled',
      colour: 'IconDestructive',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body4',
    },
  },
  'IconTextPendingM': {
    icon: {
      asset: 'Time',
      colour: 'IconWarning',
    },
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body4',
    },
  },
  'TextPaddedDefaultL': {
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body4',
    },
  },
  'TextPaddedDefaultM': {
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body4',
    },
  },
  'TextDefaultL': {
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body4',
    },
  },
  'TextDefaultM': {
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body4',
    },
  },
  'HeadingDefaultFullWidth': {
    text: {
      align: 'Left',
      styleType: 'SemiBold',
      colour: 'Dark',
      type: 'Heading4',
    },
  },
  'TextDefaultFullWidth': {
    text: {
      align: 'Left',
      styleType: 'Regular',
      colour: 'Dark',
      type: 'Body4',
    },
  },
};

const getProps = (type: string): TableCellInternalProps => {
  const values: TableCellInternalProps = propValues[type];
  if (!values) {
    console.error(`${type} props not found`);
    return {};
  }
  return values;
};

export default getProps;
